import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Typography, useTheme, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Footer } from 'components/General';
import { GeneralFlexBox } from 'components/StyledComponents';
import { GrayButtonOutlined, StandardButton } from 'components/Button';
import { RESOURCE_MENU } from 'constants/index';
import { NotFound404Icon } from 'components/ImageComponent';

/********************  Styled Components  ********************/
const LayoutContainer = styled('div')(() => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: '1440px',
  margin: '0 auto',
}));

const Title = styled(Typography)(({ theme }) => ({
  fontSize: 20,
  fontWeight: 600,
  color: theme.palette.text.main,
  margin: '32px 0',
  padding: '0 55px',
  textAlign: 'center',

  '@media(max-width: 480px)': {
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '24px',
  },
}));

/********************  Main Component  ********************/
const Notfound = () => {
  const theme = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <LayoutContainer>
        <GeneralFlexBox direction="column" padding="208px 0 209px 0" align="center">
          <NotFound404Icon fill={theme.palette.text.main} />
          <Title>We can&apos;t find the page that you&apos;re looking for</Title>

          <Stack direction="row" spacing={2}>
            <Link to="/" style={{ textDecoration: 'none' }}>
              <StandardButton width={147} height={48}>
                Take me home
              </StandardButton>
            </Link>

            <a
              href={RESOURCE_MENU.find((link) => link.text === 'Help Center')?.path}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <GrayButtonOutlined width={119} height={48}>
                I need help
              </GrayButtonOutlined>
            </a>
          </Stack>
        </GeneralFlexBox>
      </LayoutContainer>
      <Footer />
    </>
  );
};

export default Notfound;
